/**
 * @generated SignedSource<<5aa9612b567f664411493722f25cd0b8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type favouriteCell_projectsDirectoryV3$data = {
  readonly canViewIssue: {
    readonly canPerform: boolean;
  } | null | undefined;
  readonly favouriteValue: {
    readonly " $fragmentSpreads": FragmentRefs<"favouriteCell_directoryBaseV3">;
  } | null | undefined;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "favouriteCell_projectsDirectoryV3";
};
export type favouriteCell_projectsDirectoryV3$key = {
  readonly " $data"?: favouriteCell_projectsDirectoryV3$data;
  readonly " $fragmentSpreads": FragmentRefs<"favouriteCell_projectsDirectoryV3">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "favouriteCell_projectsDirectoryV3",
  "selections": [
    {
      "alias": "canViewIssue",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "VIEW_ISSUES"
        }
      ],
      "concreteType": "JiraProjectAction",
      "kind": "LinkedField",
      "name": "action",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canPerform"
        }
      ],
      "storageKey": "action(type:\"VIEW_ISSUES\")"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "JiraFavouriteValue",
      "kind": "LinkedField",
      "name": "favouriteValue",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "favouriteCell_directoryBaseV3"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "30ba154d06c0d35aed86231a00e26372";

export default node;
